import KYC from './KYC/index';
import Base from './base/CallToAction'

export default {KYC,Base}

